export default __webpack_public_path__ + "static/media/ksivalue_cube.8ea5b14c.jpg";